import {NgForm,FormGroup,FormControl,Validators,FormBuilder} from '@angular/forms'

export class UserAccountRequest {
  public ActorName: string;
  public UserName: string;
  public Password: string;
  public MobileNo: string;
  public Email: string;
  public UserType: number;
  public Remarks: string;
  public ActivationCode: string;
  public IsEncriptFromClient: boolean;
  public IsAcceptTerms: boolean;
  public TimeZoneCode: number;

  //formGroup: FormGroup = null;
  constructor() {

    //var _builder = new FormBuilder();
    //this.formGroup = _builder.group({});


    //this.formGroup.addControl('ActorNameControl', new FormControl('', Validators.required));
    //this.formGroup.addControl('UserNameControl', new FormControl('', [Validators.required]));
    //this.formGroup.addControl('PasswordControl', new FormControl('', Validators.required));
    //this.formGroup.addControl('MobileNoControl', new FormControl('', Validators.required));
    //this.formGroup.addControl('EmailControl', new FormControl('', [Validators.required, Validators.email]));
    //this.formGroup.addControl('UserTypeControl', new FormControl('', Validators.required));



    //this.formGroup = _builder.group({

    //  ActorName: ['', Validators.required],
    //  UserName: ['', [Validators.email, Validators.required]]
     
    //});

    // Adding a composite validation
    //var validationcollection = [];
    //validationcollection.push(Validators.required);
    //validationcollection.push(Validators.pattern("^[A-Z]{1,1}[0-9]{4,4}$"));
    //this.formGroup.addControl('CustomerCodeControl', new
    //  FormControl('', Validators.compose(validationcollection)));
  }  
}
